

































































import { Component, Mixins } from 'vue-property-decorator';
import InitData from 'src/mixin/initDataWithoutQuery';
import { CommonRes } from 'src/types/views/common';
import { RecommendedRequireItem, RecommendedRequireResItem } from 'src/types/views/require';
import { addRequireFavorite, delRequireFavorite } from 'service/api';

interface FavorRes {
  state: boolean;
  message: string;
}

@Component
export default class RequireRecommendation extends Mixins(InitData) {
  data: RecommendedRequireItem[] = [];

  url = 'push/pushRequire';

  pageSize = 10;

  beforeInit() {
    this.params = {
      pageNum: this.pageNum,
      pageSize: this.pageSize,
      keyword: this.keyword,
    };
    return true;
  }

  async favor(id: string, favorite: boolean) {
    const service = favorite ? delRequireFavorite : addRequireFavorite;
    const res = await service(id);
    if ((res as FavorRes).state) {
      this.$message.success(favorite ? '取消收藏成功！' : '收藏成功');
    } else {
      this.$notify.error((res as FavorRes).message);
    }
    this.init();
  }

  afterInit(res: CommonRes<RecommendedRequireResItem>) {
    this.data = res.data.rows.map(item => ({
      id: item.id,
      name: item.name,
      remainDays: item.deadTime,
      endTime: item.endTime,
      createTime: item.createTime.substr(0, 10),
      price: item.price,
      address: item.requiredareaname,
      industry: item.requiredindustryname,
      description: item.description.replace(/<[^>]+>|&nbsp;|\s+/g, ''),
      favorite: item.favorite,
    }));
    this.total = res.data.count || 0;
    return true;
  }

  toDetail(name: string, id: string) {
    this.$router.push({
      name,
      query: { id },
    });
  }
}
